import DOMPurify from "dompurify";

export const cutString = (string) => {
    if (string.length > 32) {
        string = string.substring(0,31);
        string = string + "...";
    }
    return string;
}

const COLOR_VALUE_RE =
    /^(#[0-9a-f]{3,6}|rgb(a)?\([\d\s,.]+\)|[a-z]+)$/i;

DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
    if (data.attrName === "style") {
        const onlyColor = data.attrValue
            .match(/color\s*:\s*([^;]+)/i)?.[1]
            ?.trim();

        if (onlyColor && COLOR_VALUE_RE.test(onlyColor)) {
            data.attrValue = `color:${onlyColor}`;
        } else {
            data.keepAttr = false;
        }
    }
});

export const renderTranscript = (rawHtml) => {
    let cleaned = rawHtml
        .replace(/<attachment[^>]*><\/attachment>/gi, "")
        .replace(/<img[^>]*>/gi, "");

    cleaned = DOMPurify.sanitize(cleaned, {
        ADD_TAGS: ["emoji"],
        ADD_ATTR: ["id", "alt", "title", "style"],
        ALLOWED_CSS_PROPERTIES: ["color"]
    });

    cleaned = cleaned.replace(
        /<emoji[^>]*alt="([^"]+)"[^>]*><\/emoji>/gi,
        (_m, alt) => alt
    );

    const finalHtml = DOMPurify.sanitize(cleaned, {
        ALLOWED_TAGS: [
            "strong", "b", "i", "em", "u", "s", "strike",
            "p", "br", "div", "span", "ul", "ol", "li",
            "h1", "h2", "h3", "h4", "h5", "h6",
            "blockquote", "pre", "code", "a", "at"
        ],
        ALLOWED_ATTR: [
            "style",
            "href", "title", "target",
            "id", "data-mention"
        ],
        ALLOWED_CSS_PROPERTIES: ["color"]
    });

    return (
        <div
            className="transcript-body"
            dangerouslySetInnerHTML={{ __html: finalHtml }}
        />
    );
};
